function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/system';
import Button from '../Button.js';
import Text from '../Text.js';
import { colors } from '../../theme/index.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * @param props
 * @returns {*}
 * @constructor
 */
const Transition = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Slide, _extends({
  direction: "up"
}, props)));

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const StepCompletionNotif = ({
  dialog,
  open,
  type,
  title,
  maxWidth,
  fullWidth,
  handleClose,
  handleNext,
  testid
}) => {
  const ModalStyled = styled('div')({
    overflow: 'auto',
    outline: 'none',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: colors.surface,
    height: '100%',
    maxWidth: fullWidth ? null : '500px'
  });
  const TitleIconWrapper = styled('div')({
    width: '100%',
    paddingBottom: '15px',
    color: colors.mainTextGrey,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  });
  const StyledDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
      borderRadius: 8
    },
    '& .paperWidthSm': {
      maxWidth: '500px'
    }
  });
  const formStyle = {
    flex: 1,
    paddingBottom: '0',
    paddingTop: '0',
    width: 'auto'
  };
  return /*#__PURE__*/React.createElement(StyledDialog, {
    maxWidth: maxWidth || 'md',
    fullWidth: fullWidth,
    onClose: handleClose,
    open: open,
    "aria-labelledby": title,
    TransitionComponent: Transition,
    keepMounted: true
    // disableBackdropClick={true}
    ,
    disableEscapeKeyDown: true
  }, /*#__PURE__*/React.createElement(ModalStyled, null, /*#__PURE__*/React.createElement(TitleIconWrapper, null, /*#__PURE__*/React.createElement(Text, {
    testid: testid,
    align: "center",
    bold: true,
    mediumLarge: true,
    display: "inline-block",
    margin: "0"
  }, i18n.t(tokens.labels.completed, {
    step: type
  }))), /*#__PURE__*/React.createElement("div", {
    style: formStyle
  }, /*#__PURE__*/React.createElement(Text, {
    small: true
  }, dialog), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: handleNext,
    marginTop: 2.5
  }, i18n.t(tokens.buttons.next))))));
};
export default StepCompletionNotif;